import TextInput from "../UI/TextInput";
import FormUpload from "../File/FormUpload";
import AddressFields from "../UI/AddressFields";
import Tooltip from "../UI/Tooltip";
import { Interrogation } from "../UI/Icons";

export default function ProfileFormDom({
  isBailleur,
  prefix = "",
  isMandataire,
  withOldAddressField,
  hideUpload = false,
  hideTitle = false,
}) {
  return (
    <>
      {!isMandataire && !hideTitle && (
        <h3>{isBailleur ? "Adresse" : "Adresse actuelle"}</h3>
      )}

      <div>
        <AddressFields namePrefix={prefix} />
        <TextInput
          type="text"
          name={`${prefix}pays`}
          placeholder="Pays"
          label="Pays"
          mandatory
        />
        {!isBailleur && !isMandataire && !hideUpload && (
          <>
            Justificatif de domicile
            <FormUpload tag="domicile" shouldWatermark />
          </>
        )}
      </div>
      {withOldAddressField && (
        <>
          <h3>
            Ancienne adresse{" "}
            <Tooltip
              content={
                "Cette adresse est indiquée sur le bail en tant qu'adresse actuelle du locataire"
              }
            >
              <Interrogation />
            </Tooltip>
          </h3>
          <div>
            <AddressFields namePrefix={prefix + "old_"} mandatory={false} />
          </div>
        </>
      )}
    </>
  );
}
